import { render } from "./Snippet.vue?vue&type=template&id=61957f52&bindings={\"file\":\"setup\",\"cmOptions\":\"setup\",\"languages\":\"setup\",\"isRetrieved\":\"setup\",\"isLocalFile\":\"setup\"}"
import script from "./Snippet.vue?vue&type=script&lang=js"
export * from "./Snippet.vue?vue&type=script&lang=js"

import "./Snippet.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script